<template>
  <div class="main-wrap sale-head">
    <router-link :to="{path:'/index'}" tag="div" class="logo"><img src="../../assets/images/logo.png" alt="logo"></router-link>卖家工作台
  </div>
</template>

<script>
export default {
  name: 'botNav',
    data(){
      return {

      }
    },
    components:{
    },
    computed: {

    },
    mounted(){

    },
    methods:{

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../../assets/css/common';
  .sale-head{
    overflow: hidden;
    padding:15px 0 32px;
  }
  .logo{
    display: inline-block;
    width:195px;
    height:48px;
    margin-right:25px;
    vertical-align: bottom;
    cursor: pointer;
  }


</style>

